/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { ActivitiesService } from '@app/shared/components/activities/activities.service';

@Component({
  selector: 'app-activities-button',
  templateUrl: './activities-button.component.html',
  styleUrls: ['./activities-button.component.scss'],
})
export class ActivitiesButtonComponent implements OnInit {
  @Input() subjectType: LaravelModelsEnum;
  @Input() subjectId: number;
  @Input() overlay = true;

  constructor(private activitiesService: ActivitiesService) {}

  ngOnInit() {
    this.checkRequiredFields(this.subjectType);
    this.checkRequiredFields(this.subjectId);
  }

  open() {
    this.activitiesService.show(this.subjectType, this.subjectId, this.overlay);
  }

  private checkRequiredFields(input: any): void {
    if (input === null || input === undefined) {
      throw new Error('ActivitiesButtonComponent Missing required attribute');
    }
  }
}
